"use strict";
import { useMemo } from "react";
import { useUSDCPrice } from "features/transactions/hooks/useUSDCPrice";
export function useUSDPrice(currencyAmount, prefetchCurrency) {
  const currency = currencyAmount?.currency ?? prefetchCurrency;
  const { price, isLoading } = useUSDCPrice(currency);
  return useMemo(() => {
    if (!price || !currency) {
      return { data: void 0, isLoading };
    }
    if (currencyAmount) {
      try {
        const usdAmount = price.quote(currencyAmount);
        return { data: parseFloat(usdAmount.toExact()), isLoading };
      } catch (error) {
        console.warn("Failed to convert currency amount to USD value:", error);
        return { data: void 0, isLoading };
      }
    }
    const perToken = parseFloat(price.toSignificant(8));
    return { data: Number.isFinite(perToken) ? perToken : void 0, isLoading };
  }, [currency, currencyAmount, isLoading, price]);
}
